import React from 'react';
import { IonList } from '@ionic/react';
import type { TopicMutation } from './mutations';
import TopicChangeItem from './TopicChangeItem';

const emptyStyle: React.CSSProperties = {
  color: 'var(--ion-color-medium)',
  padding: '32px 20px',
  textAlign: 'center',
};

interface TopicChangeListProps {
  mutations: readonly TopicMutation[];
  emptyMessage: string;
  /**
   * Rendered at the end of each row's header (before the chevron) — e.g. the
   * Changes page's per-row Share Updates button (#427).
   */
  renderRowEnd?: (mutation: TopicMutation) => React.ReactNode;
}

/**
 * The chronologically-ordered, collapsible list of an topic's field changes,
 * shared by the change-history subpage and the share wizard's Changes step
 * (#418, #427).
 */
const TopicChangeList: React.FC<TopicChangeListProps> = ({
  mutations,
  emptyMessage,
  renderRowEnd,
}) => {
  if (mutations.length === 0) {
    return (
      <p style={emptyStyle} data-testid="topic-changes-empty">
        {emptyMessage}
      </p>
    );
  }
  return (
    <IonList>
      {mutations.map(mutation => (
        <TopicChangeItem
          key={mutation.id}
          mutation={mutation}
          endSlot={renderRowEnd?.(mutation)}
        />
      ))}
    </IonList>
  );
};

export default TopicChangeList;
